<template>
  <div class="banner-promo">
    <div class="banner-content">
      <div class="icon-promo-wrapper" data-wptv="icon-promo">
        <wptv-icon
          :specific-alt="''"
          name="communication-r-u-ic-tag-sale"
          aria-label=""
          height="100%"
          width="100%" />
      </div>
      <div class="promo">
        <div
          class="promo-title"
          data-wptv="promotion-name">
          {{ promo.name }}
        </div>
        <div
          class="promo-description"
          data-wptv="promotion-summary">
          {{ promo.summary }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WptvIcon } from '@wptv/components/ui/icon'

export default {
  name: 'BannerPromo',
  components: { WptvIcon },
  props: {
    promo: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .banner-promo {
    .banner-content {
      background-color: $warning-color;
      max-width: 1280px;
      padding: 12px 12px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .icon-promo-wrapper {
        height: 20px;
        width: 20px;
        margin: 0 0 28px 0;
      }

      .promo {
        display: flex;
        flex-direction: column;
        margin-left: 15px;

        .promo-title {
          font-weight: bold;
          line-height: 1.43rem;
        }

        .promo-description {
          flex-grow: 1;
          flex-shrink: 1;
          line-height: 1.43rem;
          font-weight: normal;
        }
      }
    }
  }
</style>
